import {
    USER_LOGOUT_FAILURE,
    USER_LOGOUT_REQUEST,
    USER_LOGOUT_SUCCESS,
    LOAD_USER_REQUEST,
    LOAD_USER_SUCCESS,
    LOAD_USER_FAILURE,
    GET_USER_NOTICE_REQUEST,
    GET_USER_NOTICE_SUCCESS,
    GET_USER_NOTICE_FAILURE,
    SEE_USER_NOTICE_REQUEST,
    SEE_USER_NOTICE_SUCCESS,
    SEE_USER_NOTICE_FAILURE,
    UNAUTHORIZED_RESPONSE_ERROR,
    SET_DAILY_REPORT_FILTER_DATA,
    RESET_DAILY_REPORT_FILTER_DATA,
    SET_DENTIST_DETAILS_FILTER_DATA,
    RESET_DENTIST_DETAILS_FILTER_DATA,
    REMOVE_USER_NOTICE_REQUEST,
    REMOVE_USER_NOTICE_SUCCESS,
    REMOVE_USER_NOTICE_FAILURE,
} from './constants';

export function logoutUser() {
    return {
        type: USER_LOGOUT_REQUEST,
        data: {}
    }
}

export function logoutUserSuccess() {
    return {
        type: USER_LOGOUT_SUCCESS,
        data: {}
    }
}

export function logoutUserFailure() {
    return {
        type: USER_LOGOUT_FAILURE,
        data: {}
    }
}

export function loadUser() {
    return {
        type: LOAD_USER_REQUEST,
        data: {}
    }
}

export function loadUserSuccess(response) {
    return {
        type: LOAD_USER_SUCCESS,
        data: response.data
    }
}

export function loadUserFailure() {
    return {
        type: LOAD_USER_FAILURE,
        data: {}
    }
}

export function getNotice() {
    return {
        type: GET_USER_NOTICE_REQUEST,
        data: {}
    }
}

export function getNoticeSuccess(response) {
    return {
        type: GET_USER_NOTICE_SUCCESS,
        data: response.data
    }
}

export function getNoticeFailure() {
    return {
        type: GET_USER_NOTICE_FAILURE,
        data: {}
    }
}

export function seeNotice(data, userData = null) {
    return {
        type: SEE_USER_NOTICE_REQUEST,
        data: {data, userData}
    }
}

export function seeNoticeSuccess(response) {
    return {
        type: SEE_USER_NOTICE_SUCCESS,
        data: response.data
    }
}

export function seeNoticeFailure() {
    return {
        type: SEE_USER_NOTICE_FAILURE,
        data: {}
    }
}

export function removeNotice(data) {
    return {
        type: REMOVE_USER_NOTICE_REQUEST,
        data: data
    }
}

export function removeNoticeSuccess(response) {
    return {
        type: REMOVE_USER_NOTICE_SUCCESS,
        data: response,
    }
}

export function removeNoticeFailure() {
    return {
        type: REMOVE_USER_NOTICE_FAILURE,
    }
}

export function redirectOnLogOut() {
    return {
        type: UNAUTHORIZED_RESPONSE_ERROR,
        data: {}
    }
}

export function setDailyreportFilterData(data) {
    return {
        type: SET_DAILY_REPORT_FILTER_DATA,
        data
    }
}

export function resetDailyReportFilterData() {
    return {
        type: RESET_DAILY_REPORT_FILTER_DATA
    }
}

export function setDetailsFilterData(data) {
    return {
        type: SET_DENTIST_DETAILS_FILTER_DATA,
        data
    }
}

export function resetDetailsFilterData() {
    return {
        type: RESET_DENTIST_DETAILS_FILTER_DATA
    }
}



// WEBPACK FOOTER //
// ./src/containers/AuthWrapper/actions.js